import axios from "axios";
import LoaderHelper from "../../Loading/LoaderHelper";
import { alertErrorMessage } from "../../CustomAlertModel";

export const ApiCallPost = async (url, parameters, headers) => {
  try {
    const response = await axios.post(url, parameters, { headers });
    return response.data;
  } catch (error) {
    LoaderHelper.loaderStatus(false);
    if (handleTokenExpiration(error)) return;
    return error?.response?.data?.message || 'An error occurred during the request.';
  }
};

export const ApiCallGET = async (url, headers) => {
  try {
    const response = await axios.get(url, { headers });
    return response?.data;
  } catch (error) {
    if (handleTokenExpiration(error)) return;
    return error?.response?.data;
  }
};

export const ApiCallPut = async (url, parameters, headers) => {
  try {
    const response = await axios.put(url, parameters, { headers });
    return response?.data;
  } catch (error) {
    if (handleTokenExpiration(error)) return;
    return error?.response?.data;
  }
};

export const ApiCallDelete = async (url, headers) => {
  try {
    const response = await axios.delete(url, { headers });
    return response?.data;
  } catch (error) {
    if (handleTokenExpiration(error)) return;
    return error?.response?.data;
  }
};  

const handleTokenExpiration = (error) => {
  const errorMessage = error?.response?.data?.message;
  if (errorMessage === 'Invalid token.'){
    alertErrorMessage("Session expired. Please login again")
    setTimeout(()=>{
      sessionStorage.clear();
      localStorage.clear();
  
      window.location.href = "/";
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },1000)

  }  
};